export default __webpack_public_path__ + "41830ddde7a9a169a992f595a3754488.png";